import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["submitButton"]
    static values = {
        firstNameField: String,
        lastNameField: String,
        educationalLevelField: String,
        visibleToInstitutionsField: String
    }

    connect() {
        this.firstNameInput = this.element.querySelector(`input[name="${this.firstNameFieldValue}"]`)
        this.lastNameInput = this.element.querySelector(`input[name="${this.lastNameFieldValue}"]`)
        this.educationalLevelInputs = this.element.querySelectorAll(`input[name="${this.educationalLevelFieldValue}"]`)
        this.visibleToInstitutionsInputs = this.element.querySelectorAll(`input[name="${this.visibleToInstitutionsFieldValue}"]`)
        this.setupEventListeners()
        this.validateForm()
        this.setInitialFocus()
        this.setupFocusTrap()
    }

    disconnect() {
        this.removeFocusTrap()
    }

    setInitialFocus() {
        setTimeout(() => {
            if (this.firstNameInput) {
                this.firstNameInput.focus()
            }
        }, 100)
    }

    setupFocusTrap() {
        this.modalContainer = this.element.closest('[data-target="form.modal"]')
        if (this.modalContainer) {
            this.handleTabKeyBound = this.handleTabKey.bind(this)
            this.modalContainer.addEventListener('keydown', this.handleTabKeyBound)
        }
    }

    removeFocusTrap() {
        if (this.modalContainer && this.handleTabKeyBound) {
            this.modalContainer.removeEventListener('keydown', this.handleTabKeyBound)
        }
    }

    handleTabKey(event) {
        if (event.key !== 'Tab') return

        const focusableElements = this.getFocusableElements()
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]

        if (event.shiftKey) {
            if (document.activeElement === firstElement) {
                event.preventDefault()
                lastElement.focus()
            }
        } else {
            if (document.activeElement === lastElement) {
                event.preventDefault()
                firstElement.focus()
            }
        }
    }

    getFocusableElements() {
        const focusableSelectors = [
            'a[href]',
            'button:not([disabled])',
            'textarea:not([disabled])',
            'input:not([disabled]):not([type="hidden"])',
            'select:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'
        ].join(', ')

        return Array.from(this.modalContainer.querySelectorAll(focusableSelectors))
            .filter(element => {
                return element.offsetParent !== null
            })
    }

    setupEventListeners() {
        [this.firstNameInput, this.lastNameInput].forEach(input => {
            if (!input) return
            input.addEventListener('input', () => {
                input.value = input.value.replace(/[^a-zA-Z\s'-]/g, '')
                this.validateForm()
            })
        })
        
        Array.from(this.educationalLevelInputs).concat(Array.from(this.visibleToInstitutionsInputs)).forEach(input => {
            input.addEventListener('change', () => this.validateForm())
        })
    }

    validateForm() {
        const firstName = this.firstNameInput?.value.trim()
        const lastName = this.lastNameInput?.value.trim()
        const educationalLevel = this.element.querySelector(`input[name="${this.educationalLevelFieldValue}"]:checked`)
        const visibleToInstitutions = this.element.querySelector(`input[name="${this.visibleToInstitutionsFieldValue}"]:checked`)
        
        const isFormValid = firstName && lastName && educationalLevel && visibleToInstitutions

        if (!this.hasSubmitButtonTarget) return

        const button = this.submitButtonTarget
        button.disabled = !isFormValid
        
        if (isFormValid) {
            button.classList.remove('bg-[#717A8B]')
            button.classList.add('bg-[#002F87]')
        } else {
            button.classList.remove('bg-[#002F87]')
            button.classList.add('bg-[#717A8B]')
        }
    }
}
